import script from "./ApprovedLimitEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovedLimitEditor.vue?vue&type=script&setup=true&lang=js"

import "./ApprovedLimitEditor.vue?vue&type=style&index=0&id=59423d32&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59423d32"]])

export default __exports__